import keymirror from 'keymirror';

const SortOrder = keymirror({
  ASCENDING: null,
  DESCENDING: null,
  UNSORTED: null,
});

export default SortOrder;
